import { useState, useEffect } from "react";
import { useParams } from "react-router-dom"
import { useSidebar } from "../../SidebarContext";
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function SingleEarning() {
    const { isSidebarOpen } = useSidebar();
    const [filter, setFilter] = useState("all");
    const [customRange, setCustomRange] = useState({ start: "", end: "" });
    const [data1, setData1] = useState([]);
    const url = process.env.REACT_APP_LINK;
    const { id, videoId } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [user, setUser] = useState([])
    const [video, setVideo] = useState([])
    const [image, setImage] = useState("");
    const [preImage, setPreImage] = useState("");


    const filters = [
        { label: "All", value: "all" },
        { label: "Last 7 Days", value: "7days" },
        { label: "Last 14 Days", value: "14days" },
        { label: "Last 28 Days", value: "28days" },
        { label: "Last 60 Days", value: "60days" },
        { label: "Last 90 Days", value: "90days" },
        { label: "Custom", value: "custom" },
    ];

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/earningcheck/allearning/${id}`);
            const data = await response.json();
            setData1(data.data.reverse());
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };




    useEffect(() => {
        fetchUsers();
    }, []);



   const getFilteredData = () => {
        // ✅ Show all data by default
        if (!filter || filter === "all") return data1;

        return data1.filter((d) => {
            const createdAt = new Date(d.createdAt);

            if (filter === "custom" && customRange.start && customRange.end) {
                const startDate = new Date(customRange.start);
                const endDate = new Date(customRange.end);
                endDate.setHours(23, 59, 59, 999);
                return createdAt >= startDate && createdAt <= endDate;
            }

            const days = parseInt(filter.replace("days", ""));
            const cutoffDate = new Date();
            cutoffDate.setDate(cutoffDate.getDate() - days);

            return createdAt >= cutoffDate;
        });
    };



    const filteredData = getFilteredData();

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const currentData = filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const fetchUsersAll = async () => {
        try {
            const response = await fetch(`${url}/api/user/admin1997`);
            const data = await response.json();
            // setEmployees(data)
            setUser(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchVideo = async () => {
        try {
            const response = await fetch(`${url}/api/videos/admin1997`);
            const data = await response.json();
            setVideo(data.reverse());
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${url}/api/analytics/delete/${id}`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json"
                        }
                    });

                    const res = await response.json();

                    if (response.ok) {
                        Swal.fire(
                            "Deleted!",
                            "The record has been deleted.",
                            "success"
                        );
                        fetchUsers(); // refresh table
                    } else {
                        Swal.fire(
                            "Error!",
                            res.message || "Something went wrong",
                            "error"
                        );
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire(
                        "Error!",
                        "Something went wrong",
                        "error"
                    );
                }
            }
        });
    };

    useEffect(() => {
        fetchUsersAll()
        fetchVideo();
    }, [])



    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <div className="releases-analytics-container">
                {/* <div className="releases-analytics-header">
                    <h1>📊 Video Analytics</h1>
                </div> */}

                {/* Filter Bar */}
                <div className="releases-analytics-filterbar">
                    <div className="releases-analytics-filters">
                        {filters.map((f) => (
                            <button
                                key={f.value}
                                onClick={() => setFilter(f.value)}
                                className={`releases-analytics-filter-btn ${filter === f.value ? "active" : ""
                                    }`}
                            >
                                {f.label}
                            </button>
                        ))}
                    </div>

                    {filter === "custom" && (
                        <div className="releases-analytics-datepicker">
                            <input
                                type="date"
                                value={customRange.start}
                                onChange={(e) =>
                                    setCustomRange((prev) => ({ ...prev, start: e.target.value }))
                                }
                            />
                            <span>to</span>
                            <input
                                type="date"
                                value={customRange.end}
                                onChange={(e) =>
                                    setCustomRange((prev) => ({ ...prev, end: e.target.value }))
                                }
                            />
                        </div>
                    )}
                </div>

                {/* Stats Cards */}
                <div className="releases-analytics-cards">

                    <div className="releases-analytics-card">
                        <h2>Total Video Published</h2>
                        <p>
                            {filteredData.length || 0}
                        </p>
                    </div>
                    <div className="releases-analytics-card">
                        <h2>Earnings</h2>
                        <p>
                            ₹
                            {filteredData.reduce((sum, d) => sum + parseFloat(d.amount), 0) || 0}
                        </p>
                    </div>
                </div>

                {/* Video List */}
                <div >
                    {filteredData.length > 0 ? (

                        <div className="customer-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>User Id</th>
                                        <th>Name</th>
                                        <th>Video Id</th>
                                        <th>Amount</th>

                                        <th>Date</th>
                                        {/* <th>Action</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.length > 0 ? (
                                        currentData.map((employee, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {employee.staff_id}
                                                </td>

                                                <td>{employee.staff_name}</td>
                                                <td>

                                                    {employee.video_id}
                                                </td>


                                                <td>{employee.amount}</td>


                                                <td>{new Date(employee.createdAt).toLocaleString()}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="releases-analytics-nodata">No data available</p>
                    )}
                    <div className="pagination">
                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                            <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                        </button>

                        <button className="active">{currentPage}</button>

                        {currentPage + 1 < totalPages && (
                            <>
                                <button onClick={() => paginate(currentPage + 1)}>
                                    {currentPage + 1}
                                </button>
                                {currentPage + 2 < totalPages && <span className="dots">...</span>}
                                <button onClick={() => paginate(totalPages)}>
                                    {totalPages}
                                </button>
                            </>
                        )}

                        {currentPage === totalPages - 1 && (
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        )}

                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                            <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default SingleEarning;
